import { render, staticRenderFns } from "./CargoCuenta.vue?vue&type=template&id=48dbe744"
import script from "./CargoCuenta.js?vue&type=script&lang=js&external"
export * from "./CargoCuenta.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports